import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Paper, Typography, Chip } from '@mui/material';
import { Stop as EndIcon, CheckCircle as SuccessIcon } from '@mui/icons-material';
import { WorkflowNode } from '../../../../types/workflow.types';

const EndNode: React.FC<NodeProps<WorkflowNode['data']>> = ({ data, selected }) => {
  const config = data?.config || {};

  return (
    <Paper
      elevation={selected ? 8 : 2}
      style={{
        padding: 16,
        minWidth: 120,
        maxWidth: 200,
        backgroundColor: '#F44336',
        color: 'white',
        border: selected ? '3px solid #1976d2' : '1px solid #D32F2F',
        borderRadius: 8,
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
      }}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        style={{
          backgroundColor: '#D32F2F',
          border: '2px solid white',
          width: 12,
          height: 12,
        }}
      />

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <EndIcon style={{ fontSize: 20 }} />
        <Typography variant="subtitle2" fontWeight="bold">
          {data?.title || 'End'}
        </Typography>
      </div>

      {data?.description && (
        <Typography variant="caption" style={{ opacity: 0.9, fontSize: '0.7rem', marginBottom: 8, display: 'block' }}>
          {data.description}
        </Typography>
      )}

      {config?.successCriteria && (
        <div style={{ marginBottom: 8 }}>
          <Chip
            icon={<SuccessIcon style={{ fontSize: 12, color: 'white' }} />}
            label="Conditional End"
            size="small"
            style={{
              backgroundColor: 'rgba(76, 175, 80, 0.8)',
              color: 'white',
              fontSize: '0.6rem',
              height: 18,
            }}
          />
          <Typography
            variant="caption"
            style={{
              opacity: 0.8,
              fontSize: '0.65rem',
              fontFamily: 'monospace',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              padding: '2px 4px',
              borderRadius: '4px',
              display: 'block',
              marginTop: 4,
              wordBreak: 'break-all'
            }}
          >
            Success: {config?.successCriteria && config.successCriteria.length > 25 ?
              config.successCriteria.substring(0, 25) + '...' :
              config?.successCriteria}
          </Typography>
        </div>
      )}

      {config?.outputMapping && Object.keys(config.outputMapping).length > 0 && (
        <div style={{ marginBottom: 8 }}>
          <Typography variant="caption" style={{ opacity: 0.8, fontSize: '0.65rem' }}>
            Mapping {Object.keys(config?.outputMapping || {}).length} output{Object.keys(config?.outputMapping || {}).length > 1 ? 's' : ''}
          </Typography>
        </div>
      )}

      <div style={{ marginTop: 8, display: 'flex', justifyContent: 'center' }}>
        <Typography variant="caption" style={{ opacity: 0.8, fontSize: '0.65rem' }}>
          Workflow Exit Point
        </Typography>
      </div>

      {!config?.successCriteria && !config?.outputMapping && (
        <Typography variant="caption" style={{ opacity: 0.7, fontSize: '0.65rem', textAlign: 'center', display: 'block' }}>
          Simple workflow completion
        </Typography>
      )}
    </Paper>
  );
};

export default EndNode;
